import { render, staticRenderFns } from "./ProblemCount.vue?vue&type=template&id=2c9b88fa&"
import script from "./ProblemCount.vue?vue&type=script&lang=js&"
export * from "./ProblemCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports